import React, { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { Box, Icon, Modal, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import AdxButton from 'components/custom/AdxButton'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'

const CloseModal = () => {
  const [open, setOpen] = useState(false)

  const handleToggle = () => {
    setOpen((prev) => !prev)
  }
  const navigate = useNavigate()

  return (
    <React.Fragment>
      <CloseIcon onClick={handleToggle} sx={{ cursor: 'pointer' }} />
      <AdxInfoModal
        variant={'warning'}
        open={open}
        onClose={handleToggle}
        muiIcon={'error'}
        iconColor="warning.main"
        title="Do you confirm to leave the scheduler?"
        subtitle="Any progress you’ve made will not be
            saved."
        footerButtons
        firstBtnLabel={'Confirm'}
        firstBtnHandle={() => navigate(-1)}
        secondBtnLabel={'Cancel'}
        secondBtnHandle={handleToggle}
      ></AdxInfoModal>
    </React.Fragment>
  )
}

export default CloseModal
